import { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

export default function GoToTopButton() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            setIsVisible(window.scrollY > 300);
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <>
            {isVisible && (
                <button
                    onClick={scrollToTop}
                    onMouseDown={(e) => e.preventDefault()}
                    className="fixed bottom-4 right-4 md:bottom-8 md:right-8 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-full p-2 md:p-3 shadow-[0_8px_30px_rgb(0,0,0,0.12)] hover:shadow-[0_20px_60px_rgb(147,51,234,0.5)] transition-all duration-300 hover:scale-110 hover:-translate-y-1 focus:outline-none z-50 backdrop-blur-sm"
                    aria-label="Go to top"
                >
                    <ChevronUp size={24} />
                </button>
            )}
        </>
    );
}